export default class Accordion extends HTMLElement {
  static CLASS_ACTIVE = 'is-active';
  static EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';
  static DURATION = 300;

  constructor() {
    super();

    /* Binding */
    this.onClick = this.onClick.bind(this);

    /* UI */
    this.$container = this.querySelector('[data-container]');
    this.$summary = this.querySelector('[data-summary]');
    this.$content = this.querySelector('[data-content]');

    /* Data */
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    this.$summary.addEventListener('click', this.onClick);
  }

  unbindEvents() {
    this.$summary.removeEventListener('click', this.onClick);
  }

  // =============================================================================
  // Callbacks
  // =============================================================================
  onClick(e) {
    e.preventDefault();

    if (this.isClosing || !this.$container.open) {
      this.open();
    } else if (this.isExpanding || this.$container.open) {
      this.shrink();
    }
  }

  onAnimationFinish(open) {
    this.$container.open = open;

    this.$container.classList.toggle(Accordion.CLASS_ACTIVE, open);

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.$container.style.height = this.$container.style.overflow = '';
  }

  // =============================================================================
  // Methods
  // =============================================================================
  shrink() {
    this.$container.style.overflow = 'hidden';
    this.isClosing = true;
    // this.$container.classList.remove(Accordion.CLASS_ACTIVE);

    const startHeight = `${this.$container.offsetHeight}px`;
    const endHeight = `${this.$summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.$container.animate(
      {
        height: [startHeight, endHeight]
      },
      {
        duration: Accordion.DURATION,
        easing: Accordion.EASING
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => {
      this.isClosing = false;
      // this.$container.classList.add(Accordion.CLASS_ACTIVE);
    };

    this.onShrink?.(this.$container);
  }

  open() {
    this.dispatchEvent(
      new CustomEvent('accordion:open', {
        bubbles: true,
        detail: { accordion: this }
      })
    );

    this.$container.style.overflow = 'hidden';
    this.$container.style.height = `${this.$container.offsetHeight}px`;
    this.$container.open = true;

    window.requestAnimationFrame(() => this.expand());

    this.onOpen?.(this.$container);
  }

  expand() {
    this.isExpanding = true;
    // this.$container.classList.add(Accordion.CLASS_ACTIVE);

    const startHeight = `${this.$container.offsetHeight}px`;
    const endHeight = `${this.$summary.offsetHeight + this.$content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.$container.animate(
      {
        height: [startHeight, endHeight]
      },
      {
        duration: Accordion.DURATION,
        easing: Accordion.EASING
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => {
      this.isExpanding = false;
      // this.$container.classList.remove(Accordion.CLASS_ACTIVE);
    };
  }
}
